import { useQuery } from "@tanstack/react-query";

import useCurrentStateAndParamsWithFixedDomain from "app/pages/sales-intelligence/modules/company-analysis/hooks/useCurrentStateAndParamsWithFixedDomain";
import salesApiService from "app/pages/sales-intelligence/services/salesApiService";

const BASE_SETTINGS_QUERY_KEY = "account-overview:base-settings";

export default function useBaseSettingsQuery() {
    const {
        params: { key: domain },
    } = useCurrentStateAndParamsWithFixedDomain();

    return useQuery({
        staleTime: Number.POSITIVE_INFINITY,
        queryKey: [BASE_SETTINGS_QUERY_KEY, domain],
        queryFn({ signal }) {
            return salesApiService.companyAnalysis.fetchBaseSettings(domain, {
                cancellation: signal,
            });
        },
    });
}
